"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = WebSocket;
//# sourceMappingURL=ws.js.map